<template>
  <a-modal title="Chat umbenennen" v-model:open="renameModalVisible" okText="Speichern" @ok="renameCase()">
    <a-input v-model:value="caseNewName" placeholder="Basic usage" />
  </a-modal>
  <div style="height: 100%; overflow-y: auto" class="sidebar_dynamic_item">
    <a-menu style="background-color: #f0f2f5" @select="onMenuItemSelected" v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys" mode="inline">
      <a-button
        type="primary"
        style="width: 100%; margin-top: 24px"
        @click="
          () => {
            selectedKeys = [];
            eventBus.emit('on-llm-home');
          }
        "
      >
        <template #icon>
          <HomeOutlined />
        </template>
        Startseite | Neuer Chat
      </a-button>
      <a-sub-menu
        @titleClick="
            ({key} : {key:string}) => {
              if (collapsed) {
              //  collapsed = false;
                  nextTick(() => {
openKeys.push(key);
              })
            }
          }
          
          "
        class="llm_history_item"
        :key="key"
        v-for="(group, key) of cases"
      >
        <template #title>{{ key }} </template>
        <a-menu-item v-for="item of group" :key="item.id">
          <div class="llm_menu_item" style="display: flex; align-items: center; justify-content: space-between">
            <span style="flex-grow: 1; flex-shrink: 1; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{ item.name }}</span>
            <a-popover class="edit_button" placement="bottomLeft" trigger="hover" style="flex-shrink: 0">
              <MoreOutlined @click="(e: MouseEvent) => { e.stopPropagation();}" />
              <template #content>
                <div style="display: flex; flex-direction: column">
                  <a-space direction="vertical">
                    <a-button style="width: 100%" @click="(e: MouseEvent) => { openRenameDialog(item.id, item.name) }"> Umbenennen </a-button>
                    <a-button style="width: 100%" @click="eventBus.emit('on-case-export', { id: item.id })">Exportieren</a-button>
                    <a-button @click="eventBus.emit('on-case-delete', { id: item.id })" style="width: 100%">Löschen</a-button>
                  </a-space>
                </div>
              </template>
            </a-popover>
          </div>
        </a-menu-item>
      </a-sub-menu>
      <a-button
        :disabled="pagination.current == pagination.total"
        style="width: 100%"
        @click="
          () => {
            collapsed = false;
            loadMoreCases();
          }
        "
      >
        Mehr laden
      </a-button>
    </a-menu>
    <!-- <div class="draghandle" @mousedown="initResize" style="width: 6px; height: 100%"></div> -->
  </div>
</template>
<script lang="ts">
import { VNode, defineComponent, nextTick, onMounted, onUnmounted, reactive, ref, toRefs, watch } from "vue";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  MailOutlined,
  DesktopOutlined,
  MoreOutlined,
  InboxOutlined,
  AppstoreOutlined,
  HistoryOutlined,
  PlusCircleOutlined,
  HomeOutlined,
} from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { updateCase } from "../../api/cases";
import eventBus from "../workflow/eventBus";
import { storeToRefs } from "pinia";
import { useLLMCaseListStore } from "../../store/modules/llmCaseList";

interface State {
  collapsed: boolean;
  selectedKeys: string[];
  openKeys: string[];
  preOpenKeys: string[];
  width: number;
  renameModalVisible: boolean;
  renamingCaseId: string;
  caseNewName: string;
}

export default defineComponent({
  components: {
    MenuFoldOutlined,
    PlusCircleOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined,
    MailOutlined,
    DesktopOutlined,
    HomeOutlined,
    MoreOutlined,
    InboxOutlined,
    AppstoreOutlined,
    HistoryOutlined,
  },

  setup(props, { emit }) {
    const store = useLLMCaseListStore();
    const { cases, pagination } = storeToRefs(store);
    const { updateCaseList, loadMoreCases } = store;

    const router = useRouter();
    const removeAfterEach = router.afterEach((to) => {
      if (to.name === "Large Language Model") {
        store.updateCaseList();
      }
    });

    onMounted(() => {
      store.updateCaseList();
    });

    onUnmounted(() => {
      removeAfterEach();
    });

    const state = reactive<State>({
      collapsed: true,
      selectedKeys: [],
      openKeys: [""],
      preOpenKeys: [""],
      width: 400,
      renameModalVisible: false,
      renamingCaseId: "",
      caseNewName: "",
    });

    const route = useRoute();

    watch(
      () => route.params,
      () => {
        if (route.params["caseId"] && route.params["caseId"].length > 8) {
          state.selectedKeys = [route.params["caseId"]];
        }
      },
      { deep: true }
    );

    watch(
      () => state.openKeys,
      (_val, oldVal) => {
        state.preOpenKeys = oldVal;
      }
    );

    const containerRef = ref<VNode | null>(null);

    function initResize() {
      window.addEventListener("mousemove", resize, false);
      window.addEventListener("mouseup", stopResize, false);
    }

    const resize = (e: MouseEvent) => {
      if (containerRef.value == null || containerRef.value.$el == null) {
        return;
      }
      let width = containerRef.value.$el.offsetLeft as number;
      state.width = e.clientX - width;
    };

    function stopResize(e: MouseEvent) {
      window.removeEventListener("mousemove", resize, false);
      window.removeEventListener("mouseup", stopResize, false);
    }

    const toggleCollapsed = () => {
      //    state.collapsed = !state.collapsed;
      // state.openKeys = state.collapsed ? [] : state.preOpenKeys;
    };

    const onMenuItemSelected = ({ key, target }: { key: string; target: any }) => {
      eventBus.emit("on-case-selected", { id: key, interuptProgress: true });
    };

    const openRenameDialog = async (caseId: string, curName: string) => {
      state.renameModalVisible = true;
      state.renamingCaseId = caseId;
      state.caseNewName = curName;
    };

    const renameCase = async () => {
      try {
        await updateCase({ id: state.renamingCaseId, title: state.caseNewName, type: "llm" });
        state.renamingCaseId = "";
        state.renameModalVisible = false;
        await updateCaseList();
        return Promise.resolve();
      } catch {
        return Promise.reject();
      }
    };

    return {
      cases,
      pagination,
      loadMoreCases,
      ...toRefs(state),
      toggleCollapsed,
      onMenuItemSelected,
      props,
      openRenameDialog,
      renameCase,
      emit,
      containerRef,
      initResize,
      eventBus,
      nextTick,
    };
  },
});
</script>
<style>
.llm_doc_browser .ant-layout-sider {
  margin-right: 12px;
}
.llm_doc_browser {
  background-color: #f5f7fa !important;
}
.llm_doc_browser .ant-menu {
  background-color: #f5f7fa !important;
}
.llm_doc_browser .ant-menu-submenu-title {
  padding-left: 16px !important;
}
</style>
<style>
.llm_menu_item .edit_button {
  font-size: 24px !important;
}

.llm_menu_item .edit_button {
  display: none !important;
}

.llm_menu_item:hover .edit_button {
  display: block !important;
}

.draghandle {
  position: absolute;
  z-index: 100;
  width: 8px;
  top: 0;
  bottom: 0;
  right: 0;
  cursor: col-resize;
  float: right;
}

.llm_history_item {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.ant-popover {
  z-index: 5000 !important;
}
</style>
